import { createStepper } from 'shared';

import { STEPPER_ROUTES } from './lib/stepper';
import { PaymentAwaitingCryptoView, PaymentAwaitingDebitView } from './ui/payment-awaiting';
import { PaymentConfirmationCryptoView, PaymentConfirmationDebitView } from './ui/payment-confirmation';
import { PaymentMethodsView } from './ui/payment-method';
import { SelectPackageView } from './ui/payment-select-package';
import { OwnedNftSuccess, PaymentSuccessView } from './ui/payment-success';

export const Stepper = createStepper({
  steps: [
    {
      route: STEPPER_ROUTES.PAYMENT_INITIAL,
      component: <SelectPackageView />,
    },
    {
      route: STEPPER_ROUTES.PAYMENT_SELECT_METHOD,
      component: <PaymentMethodsView />,
    },
    {
      route: STEPPER_ROUTES.PAYMENT_CRYPTO_CONFIRMATION,
      component: <PaymentConfirmationCryptoView />,
    },
    {
      route: STEPPER_ROUTES.PAYMENT_DEBIT_CONFIRMATION,
      component: <PaymentConfirmationDebitView />,
    },
    {
      route: STEPPER_ROUTES.PAYMENT_CRYPTO_AWAITING,
      component: <PaymentAwaitingCryptoView />,
    },
    {
      route: STEPPER_ROUTES.PAYMENT_DEBIT_AWAITING,
      component: <PaymentAwaitingDebitView />,
    },
    {
      route: STEPPER_ROUTES.PAYMENT_SUCCESS,
      component: <PaymentSuccessView />,
    },
    {
      route: STEPPER_ROUTES.OWNED_NFT,
      component: <OwnedNftSuccess />,
    },
  ],
});
